<header mat-dialog-title>
  <div class="dialog-header">
    <h2 class="mat-h2">Crear meta</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</header>
<mat-dialog-content class="modal-central-container">
  <form>
    <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
      <h2 class="mat-h2"> {{displayLang | i18nSelect: {'es': 'Enunciado de la meta', 'en': 'Statement of the goal', 'fr': "Déclaration de l'objectif"} }}</h2>
      <div class="langbar">
        <!-- <label class="langbar__label">Idioma:</label> -->
        <!-- <button mat-button color="primary" [ngClass]="{'on': displayLang == 'Es'}"
                (click)="displayLang ='Es'">Español
        </button>
        <button mat-button color="primary" [ngClass]="{'on': displayLang == 'En'}"
                (click)="displayLang ='En'">English
        </button>
        <button mat-button color="primary" [ngClass]="{'on': displayLang == 'Fr'}"
                (click)="displayLang ='Fr'">Français
        </button> -->
        <button *ngFor="let idioma of idiomas" mat-button color="primary" [ngClass]="{'on': displayLang == idioma}"
        [color]="displayLang == idioma ? 'warn' : ''" (click)="displayLang = idioma">{{idioma | i18nSelect: {'es': 'Español', 'en': 'English', 'fr': 'Français'} }}
        </button>
      </div>
    </div>
    <div *ngFor="let idioma of idiomas">
      <div [ngStyle]="{'display': displayLang == idioma ? 'block' : 'none'}" class="enunciado-ck-container">
        <ckeditor appCkeditorImageDelete [name]="'html' + idioma.toUpperCase()" [editor]="inlineEditor" [formControl]="descripcionForm.get(idioma)"
          [config]="{language: idioma, url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken, origen: 'Unidad', store: 'Estudio'}"
          [class]="'espanol'"
          ></ckeditor>
          <!-- No funciona el placeholder en ckeditor -->
          <!-- [placeholder]="idioma | i18nSelect: {'es': 'Escriba aquí...', 'en': 'Write here...', 'fr': 'Ecrire ici...'}" -->
      </div>
    </div>
    <!-- <div *ngIf="displayLang == 'Es'" class="enunciado-ck-container">
      <ckeditor name="htmlES"
                [editor]="inlineEditor"
                [(ngModel)]="htmlES"
                [data]="htmlES"
                [config]="{language: 'es', url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken}"
                [ngModelOptions]="{standalone: true}"></ckeditor>
    </div>
    <div *ngIf="displayLang == 'En'" class="enunciado-ck-container">
      <ckeditor name="htmlEN"
                [editor]="inlineEditor"
                [(ngModel)]="htmlEN"
                [data]="htmlEN"
                [config]="{language: 'en', url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken}"
                [ngModelOptions]="{standalone: true}"></ckeditor>

    </div>
    <div *ngIf="displayLang == 'Fr'" class="enunciado-ck-container">
      <ckeditor name="htmlFR"
                [editor]="inlineEditor"
                [(ngModel)]="htmlFR"
                [data]="htmlFR"
                [config]="{language: 'fr', url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken}"
                [ngModelOptions]="{standalone: true}"></ckeditor>

    </div> -->
    <mat-form-field [class]="'full-width'" appearance="outline">
      <mat-label>Tipo de meta</mat-label>
      <mat-select placeholder="Tipo de meta" [formControl]="tipoMeta">
        <mat-option *ngFor="let categoria of tiposMeta" [value]="categoria.id">
          {{categoria.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-error *ngIf="tipoMeta.hasError('required') && tipoMeta.pristine">El tipo de meta es obligatorio.</mat-error>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="guardando">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="guardando" (click)="guardar()">Guardar</button>
</mat-dialog-actions>
